import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector, inject } from '@angular/core';

import { OverlayFactory } from '@frontend/vanilla/shared/overlay-factory';

import { BetstationActiveSessionInfoOverlayComponent } from './betstation-active-session-info-overlay.component';
import { BetstationLoginErrorOverlayComponent } from './betstation-login-error-overlay.component';
import { BETSTATION_LOGIN_ERROR, MESSAGE_DATA, MessageData } from './betstation-login.models';

@Injectable({ providedIn: 'root' })
export class BetstationLoginErrorOverlayService {
    overlayRef: OverlayRef | undefined;

    private currentRef: OverlayRef | undefined;

    private readonly injector = inject(Injector);
    private readonly overlay = inject(OverlayFactory);

    /**
     * @internal
     */
    showLoginErrorOverlay(message: string) {
        this.overlayRef = this.createOverlay();

        const portal = new ComponentPortal(
            BetstationLoginErrorOverlayComponent,
            null,
            Injector.create({
                providers: [
                    { provide: OverlayRef, useValue: this.overlayRef },
                    { provide: BETSTATION_LOGIN_ERROR, useValue: message },
                ],
                parent: this.injector,
            }),
        );

        this.overlayRef?.attach(portal);
        this.currentRef = this.overlayRef;
    }

    /**
     * @internal
     */
    showActiveSessionInfoOverlay(messageData: MessageData) {
        this.overlayRef = this.createOverlay();

        const portal = new ComponentPortal(
            BetstationActiveSessionInfoOverlayComponent,
            null,
            Injector.create({
                providers: [
                    { provide: OverlayRef, useValue: this.overlayRef },
                    { provide: MESSAGE_DATA, useValue: messageData },
                ],
                parent: this.injector,
            }),
        );

        const componentRef = this.overlayRef?.attach(portal);
        componentRef?.setInput('messageData', messageData);
        this.currentRef = this.overlayRef;
    }

    private createOverlay(): OverlayRef | undefined {
        if (this.currentRef) {
            return;
        }

        const overlayRef = this.overlay.create({
            panelClass: ['generic-modal-popup'],
        });

        overlayRef.detachments().subscribe(() => {
            this.overlay.dispose(overlayRef);
            this.currentRef = undefined;
        });

        return overlayRef;
    }
}
